import React, {Fragment} from 'react';
import Button from "../../Button";
import TextInput from '../../TextInput';
import CheckBox from '../../CheckBox';
import Select from '../../Select';
import Modal from "../../../layout/Modal";
import Portal from "../../../layout/Portal";
import {set, get} from '../../../../utils/dotutils';
import htmlspecialchars from "locutus/php/strings/htmlspecialchars";
import {optionsTemplate} from "../../../../utils/formatters";
import {isEmpty} from "../../../../utils/other";
import ComponentConfig from "../../ComponentConfig";

const LinkNode = (props) => <a href="">{props.children}</a>;

const isLink = (value) => value.inlines.size + "" === "1" && value.inlines.find((inline) => inline.type + "" === 'link');

export const LinkModal = (props) => {
    const {type, value, target} = props.data;
    return <div className="row">
        <div className="col-md-12">
            <div className="row form-row">
                <div className="col-md-12">
                    <Select name="type" objectValue={false} optionname="linktype" storeType="local" saveChanges={props.setValue} value={type} label="Link típusa" />
                </div>
            </div>
            <div className="row form-row">
                <div className="col-md-12">
                    {type && type !== "url"
                        ?
                            <ComponentConfig componentName={type}>
                                {(configProps) => {
                                    const urlField = Object.keys(configProps.componentConfig.fielddefs || {}).find((field) => {
                                        return configProps.componentConfig.fielddefs[field].object === "url"
                                    });
                                    let valueKey = configProps.componentConfig.idfield;
                                    if (urlField) {
                                        valueKey = configProps.componentConfig.fielddefs[urlField].boundfield || valueKey;
                                    }
                                    return <Select
                                        name="value"
                                        objectValue={false}
                                        component={type}
                                        valueKey={valueKey}
                                        groupBy={{
                                            by: [valueKey]
                                        }}
                                        optionsTemplate={optionsTemplate(type)}
                                        saveChanges={props.setValue}
                                        storeType="remote"
                                        value={value}
                                        label="Link tárgya"
                                    />
                                }
                            }
                            </ComponentConfig>
                        :
                        <TextInput name="value" value={value || ''} saveChanges={props.setValue} label="Url" />
                    }
                </div>
            </div>
            {props.targetAble !== false && <div className="row form-row">
                <div className="col-md-12">
                    <CheckBox name="target" saveChanges={(field, value) => props.setValue(field, value ? '_blank' : null)} value={!!target} checked={!!target} label="Megnyitás új ablakban" />
                </div>
            </div>}
        </div>
    </div>;
};

const UnlinkButton = (props) => {
    return <Button
        onClick={(e) => {
            const editor = props.editor.unwrapInline('link');
            props.saveEditing && props.saveEditing(editor);
            return false;
        }}
        icon="unlink"
        color="default"
        tooltip="Link törlése"
        disabled={props.disabled || !isLink(props.value)}
    />
};

const defaultEditData = {
    type: 'link', target: ''
}

class LinkButton extends React.Component {

    state = {
        editing: false
    }

    openEditor = (e) => {
        e && e.preventDefault();
        let propsValue = null;
        if (isLink(this.props.value)) {
            const linknode = this.props.value.inlines.find((inline) => inline.type + "" === 'link');
            propsValue = {...linknode.data.toObject()};
        } else {
            propsValue = {...defaultEditData};
        }
        let values = {...(propsValue.presetdata || {})};
        if (propsValue.filter) {
            if (typeof propsValue.filter === "string") {
                propsValue.filter = JSON.parse(htmlspecialchars(propsValue.filter));
            }
            let type = null;
            let value = null;
            propsValue.filter.map((filter) => {
                if (filter.field === "component") {
                    type = filter.value;
                }
                if (filter.field === "component_id") {
                    value = filter.value;
                }
            });
            values.type = type;
            values.value = value;
        } else {
            values.type = "url";
            values.value = values.url;
        }
        this.setState({editing: true, value: values});
        return false;
    }

    onModalChange = (field, value) => {
        const newValue = {...this.state.value};
        set(newValue, field, value);
        if(field + "" === 'type' && value + "" !== "" + this.state.value.type) {
            newValue.value = null;
        }
        this.setState({value: newValue});
    }

    render() {
        const values = this.state.value || {};
        return <Fragment>
            <Button
                onClick={this.openEditor}
                icon="link"
                color={isLink(this.props.value) ? "primary" : "default"}
                tooltip={"Link" + (!isLink(this.props.value) ? " beszúrása" : " szerkesztése")}
                disabled={this.props.disabled || !isLink(this.props.value) && !this.props.value.selection.isExpanded}
            />
            <Portal>
                <Modal
                    state={this.state.editing ? "on" : "off"}
                    header={"Link" + (!isLink(this.props.value) ? " beszúrása" : " szerkesztése")}
                    buttons={[
                        {
                            text: "Ok",
                            props: {color: "primary", disabled: isEmpty(values.value)},
                            onClick: async () => {
                                let editor = null;
                                const value = {...this.state.value};
                                const data = {presetdata: {target: value.target}};
                                if (value.type === "url") {
                                    data.presetdata.url = value.value;
                                } else {
                                    data.filter = [{field: "component", value: value.type},{field: "component_id", value: value.value}];
                                }
                                this.setState({editing:false});
                                if (!isLink(this.props.value)) {
                                    editor = this.props.editor
                                        .wrapInline({type: 'link', data})
                                        .focus();
                                } else {
                                    editor = this.props.editor
                                        .setInlines({type: 'link', data})
                                        .focus();
                                }
                                this.props.saveEditing && this.props.saveEditing(editor);
                            }
                        }, {
                            text: "Mégse",
                            props: {color: "default"},
                            onClose: true,
                            onClick: async () => {
                                this.setState({editing:false});
                            }
                        }
                    ]}>
                    <LinkModal data={values} setValue={this.onModalChange} />
                </Modal>
            </Portal>
        </Fragment>
    }
}

export {LinkNode, LinkButton, UnlinkButton};